module.exports = __webpack_public_path__ + "files/81ab95e4bae239656034b9e6e62dcaaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size4-Regular.ttf
// module id = 1209
// module chunks = 76